<template>
    <v-layout column _login-section>
      <v-flex app-bg-sand class="p-relative">
            <v-container fill-height grid-list-xl w--max--800>
                <v-layout column text-xs-center>
                    <v-flex tag="h2"
                            class="_login-section--sub-title">Login
                    </v-flex>

                    <!--EMAIL-->
                    <v-flex>
                        <auth-login-email></auth-login-email>
                    </v-flex>


                    <!-- Social icons -->
                    <!--<v-flex class=" column align-center">
                        <v-btn class="primary v-btn--default elevation-0"
                            @click="social('facebook')">
                            <div >Login with Facebook</div>
                        </v-btn>
                        <v-btn class="primary v-btn--default elevation-0"
                            @click="social('google')">
                            <div >Login with Google</div>
                        </v-btn>
                    </v-flex>-->
                    <!-- Social icons end-->

                 
                </v-layout>
            </v-container>
            <!--BACKGROUND ELEMENTS-->
            <v-flex v-if="$vuetify.breakpoint.mdAndUp"
                    class="_login-section--bg-elements">
                <app-scroll-patterns svgName="brand/NG_CREATIVE_PLAY" v-if="$vuetify.breakpoint.mdAndUp"
                          svgTop="-320px"
                          svgClass="svg-icon-creative"
                          svgRight="190px"
                          svgWidth="122px"
                          svgHeight="122px"
                          svgColor="var(--yellow)"
                          duration="2"
                          moveX=-1
                          moveY=3>
                </app-scroll-patterns>
                <app-scroll-patterns svgName="patterns/NG_Pattern-16" v-if="$vuetify.breakpoint.mdAndUp"
                          svgTop="-800px"
                          svgClass="svg-icon-pattern"
                          svgLeft="40px"
                          svgWidth="122px"
                          svgHeight="122px"
                          svgColor="none var(--orange)"
                          duration="1"
                          moveX=0
                          moveY=2>
                </app-scroll-patterns>
            </v-flex>
        </v-flex>
      <v-flex class="_login-section--benefits">
          <v-container fill-height grid-list-xl>
              <app-auth-benefits></app-auth-benefits>
          </v-container>
      </v-flex>
        

    </v-layout>
</template>

<script>
  import AppScrollPatterns from '../../../../components/app-scroll-patterns'
  import AuthSocial from '../components/auth-social'
  import AuthLoginEmail from '../components/auth-login-email'
  import AppAuthBenefits from '../components/app-auth-benefits'

  export default {
    components: {AppScrollPatterns, AppAuthBenefits, AuthLoginEmail, AuthSocial},
    props: {
    inputRole: {
      type: String,
      default: 'parent'
    },
    viewLogin: Boolean,
    register: Boolean
  },
  data () {
    return {
      loading: {
        facebook: false,
        google: false
      },
      code: this.$route.query.code,
      type: this.$route.params.type // <- provider
    }
  },
  methods: {
    social (type) {
      this.loading[type] = true
      this.$auth.oauth2({
        provider: type || this.type,
        params: {
          redirect_uri: this.redirectURI(type),
          // Specifies value that the application uses to maintain state
          // between your authorization request and the authorization server's response
          state: (this.register ? 'register' : 'login')
        }
      })
    },
    redirectURI (type) {
      return `${this.$auth.options.getUrl()}/oauth2/${type || this.type}/${this.role}`
    }
  }
  }
</script>

<style lang="stylus" scoped>
    ._login-section
        position relative
        &--sub-title
            margin-top 0px
            @media (min-width 600px)
                margin-top 0px
                margin-bottom 0px
            &.sub-title_second
                margin-top 0
                @media (min-width 600px)
                    margin-bottom 62px
        &--divider
            @media (min-width 600px)
                margin-top 0px
                margin-bottom 0px
            .svg-icon
                width 100px
                height 50px
                color var(--yellow)
                @media (min-width 600px)
                    width 139px
        &--benefits
            padding 0px
        &--bg-elements
            .svg-icon
                position absolute
                width 122px
                height 122px
                &--creative
                    color var(--yellow)
                    right 90px
                    bottom 350px
                &--pattern
                    left 40px
                    top 180px
</style>



// WEBPACK FOOTER //
// src/views/app/auth/login/index.vue